<auth-anon-layout
  [title]="pageTitle"
  [subtitle]="pageSubtitle"
  [icon]="pageIcon"
  [showReadonlyHostname]="showReadonlyHostname"
  [maxWidth]="maxWidth"
  [hideCardWrapper]="hideCardWrapper"
  [hideBackgroundIllustration]="hideBackgroundIllustration"
  [hidePageIcon]="hidePageIcon"
  [contentVerticalPadding]="contentVerticalPadding"
  [footerVerticalPadding]="footerVerticalPadding"
  [heroTextAlignment]="heroTextAlignment"
  [secondaryContentLocation]="secondaryContentLocation"
>
  <router-outlet slot="header-actions" name="header-actions"></router-outlet>
  <router-outlet></router-outlet>
  <!-- The shared layout exposes two distinct slot selectors. We pick which one -->
  <!-- to project into based on the route-level secondaryContentLocation flag. -->
  @if (secondaryContentLocation === "footer") {
    <router-outlet slot="footer-secondary" name="secondary"></router-outlet>
  } @else {
    <router-outlet slot="secondary" name="secondary"></router-outlet>
  }
</auth-anon-layout>
